/**
* Functions to add listeners to hide and show lightbox, 
* center on window resize,
* add create background behind lightbox
*/

(function($){
	window.M1 = M1 || {};
	M1.Lightbox = {};
	function windowChangedAction(){
		var lightbox = $('#lightbox.visible');
		//only reposition dropdown if it is visible
		if(lightbox.length < 1){
			return;
		}
		M1.Lightbox.displayLightboxBackground();
		M1.util.centerElement(lightbox);
	}

	M1.Lightbox.displayLightboxBackground = function(){
		var lightbox_background = $('#lightbox_background');
		lightbox_background.addClass('visible');
		var totalPageHeight = $(document).height();
		var totalPageWidth = $(document).width();
		lightbox_background.css({
			'width': totalPageWidth,
			'height': totalPageHeight,
		});
	}
	function displayLightbox(data){
		$('#lightbox_title').html(data.title);
		$('#lightbox_description').html(data.description);
		$('#lightbox_price').html(data.price);
		$('#lightbox_video').html(data.video);
		var lightbox = $('#lightbox');
		lightbox.addClass('visible');
		M1.util.centerElement(lightbox);
		M1.Lightbox.displayLightboxBackground();
	}
	M1.Lightbox.hide = function(){
		var lightbox = $('#lightbox');
		lightbox.removeClass('visible');
		var lightbox_background = $('#lightbox_background');
		lightbox_background.removeClass('visible');
		$('.share_this_container').hide();
	}
	/*
	* center lightbox on window resize
	*/
	$(window).resize(function() {
		windowChangedAction();
	});

	/*
	* add listener to hide lightbox
	*/
	$('#lightbox .button_close, #lightbox_background').on('click', function(event) {
		M1.Lightbox.hide();
	});
	/*
	* add listener to show lightbox
	*/
	$('.lightbox_trigger').on('click', function(event) {
		event.preventDefault();
		var recommended_container = $(this).closest('.recommended_container');
		displayLightbox(recommended_container.data('course'));
		var share_link = recommended_container.find('.button_share a').attr('href');
		$('#lightbox .button_share a').attr('href', share_link);
		fill_course_data(recommended_container);
	});

	var fill_course_data = function(recommended_container){
		$('#lightbox .recommended_container').data('course', recommended_container.data('course'));
		$('#lightbox .button_add').html($(recommended_container).find('.button_add').clone(true));
	};


})(jQuery);


